// src/App.js
import React, { Component, useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Navbar from "./components/Navbar";
import Dashboard from "./components/Dashboard";
import Login from "./components/Login";
import Signup from "./components/Signup";
import ResidentialRental from "./components/ResidentialRental";
import ProtectedRoute from "./components/ProtectedRoute";
import FilterPage from "./components/FilterPage";
import Footer from "./components/Footer";
import PaymentStatusPage from "./components/PaymentStatusPage";
import SavedProperties from "./components/SavedProperties";
import Profile from "./components/Profile";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import styles from "./App.css";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsAndCondition from "./components/TermsAndCondition";
import Disclaimer from "./components/Disclaimer";
import AboutUs from "./components/About-us";
import ContactUs from "./components/ContactUs";
import List from "./components/List";
import PropertyListed from "./components/PropertyListed";
import { analytics } from './firebase';
import { logEvent } from 'firebase/analytics';
import { 
  requestNotificationPermission, 
  onMessageListener,
  isNotificationSupported,
  areNotificationsBlocked,
  getNotificationInstructions,getNotificationPermission
} from './firebase';
import { toast } from 'react-toastify';

const App = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [notificationPermission, setNotificationPermission] = useState(requestNotificationPermission());
  const [showNotificationBlockedAlert, setShowNotificationBlockedAlert] = useState(false);

  // Check if the popup was previously dismissed or the website is already added to home screen
  useEffect(() => {
    const isPopupDismissed = localStorage.getItem("popupDismissed");
    const isAddedToHomeScreen = localStorage.getItem("addedToHomeScreen");

    if (!isPopupDismissed && !isAddedToHomeScreen) {
      setShowPopup(true);
    }

    // Listen for beforeinstallprompt event
    const beforeInstallPromptListener = (e) => {
      // Prevent the mini-infobar from appearing on mobile
      e.preventDefault();
      console.log(e)
      setDeferredPrompt(e); // Save the event for later use
    };

    window.addEventListener("beforeinstallprompt", beforeInstallPromptListener);

    return () => {
      window.removeEventListener(
        "beforeinstallprompt",
        beforeInstallPromptListener
      );
    };
  }, []);

  useEffect(() => {
    // Initialize notifications
    const initializeNotifications = async () => {
      if (!isNotificationSupported()) {
        console.log("Notifications are not supported in this browser");
        return;
      }

      if (areNotificationsBlocked()) {
        setShowNotificationBlockedAlert(true);
        return;
      }

      const { token, permission, error, instructions } = await requestNotificationPermission();
      
      if (token) {
        console.log("FCM Token:", token);
        // Store this token in your backend
        // await storeTokenInBackend(token);
        
        logEvent(analytics, 'notification_permission', {
          status: 'granted'
        });
      } else if (error === 'notifications-blocked') {
        setShowNotificationBlockedAlert(true);
       
      } else if (error) {
        toast.error(error, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }

      setNotificationPermission(permission);
    };

    initializeNotifications();

    // Set up message listener
    const unsubscribe = onMessageListener()
      .then((payload) => {
        console.log("Received foreground message:", payload);
        
        // Show a toast notification
        toast.info(payload.notification?.body || "New notification received", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });

        // Log the event
        logEvent(analytics, 'notification_received', {
          notification_type: payload.notification?.title || 'unknown'
        });
      })
      .catch((err) => {
        console.error("Failed to receive message:", err);
        logEvent(analytics, 'notification_error', {
          error: err.message
        });
      });

    return () => {
      // Cleanup if needed
      if (typeof unsubscribe === 'function') {
        unsubscribe();
      }
    };
  }, []);

  const handleAddToHomeScreen = () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === "accepted") {
          logEvent(analytics, 'add_to_home_screen', {
            outcome: 'accepted'
          });
          localStorage.setItem("addedToHomeScreen", "true");
          setShowPopup(false);
        } else {
          logEvent(analytics, 'add_to_home_screen', {
            outcome: 'rejected'
          });
        }
        setDeferredPrompt(null);
      });
    }
  };

  const handleDismissPopup = () => {
    setShowPopup(false);
    localStorage.setItem("popupDismissed", "true"); // Mark the popup as dismissed
  };

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  return (
    <Router>
      <ToastContainer
        position="top-right" // Customize as needed
        autoClose={5000} // Auto close after 5 seconds
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
   
      <Navbar />
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />{" "}
        <Route path="/terms-and-condition" element={<TermsAndCondition />} />{" "}
        <Route path="/disclaimer" element={<Disclaimer />} />{" "}
        <Route path="/about-us" element={<AboutUs />} /> {/* Public Route */}
        <Route path="/contact-us" element={<ContactUs />} />{" "}
        <Route path="/list" element={<List />} />
        <Route path="/property-listed" element={<PropertyListed />} />
      

        {/* Public Route */}
        <Route
          path="/filter"
          element={<ProtectedRoute element={FilterPage} />}
        />
        <Route
          path="/residential-rental"
          element={<ProtectedRoute element={ResidentialRental} />}
        />
        <Route
          path="/saved-properties"
          element={<ProtectedRoute element={SavedProperties} />}
        />
        <Route
          path="/my-profile"
          element={<ProtectedRoute element={Profile} />}
        />
        <Route
          path="/payment-success"
          element={<ProtectedRoute element={PaymentStatusPage} />}
        />
        <Route
          path="/list"
          element={<ProtectedRoute element={List} />}
        />
       
        
       
       
        {/* Add more routes as needed */}
      </Routes>
      <Footer />
      
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-container">
            <button className="popup-close-btn" onClick={handleClosePopup}>
              &times;
            </button>
            <h2 className="popup-header">Add to Home Screen</h2>
            <p className="popup-description-text">
              To have quick access to our website, add it to your home screen
              for easy access anytime!
            </p>
            <div className="popup-button-container">
              <button className="popup-add-btn" onClick={handleAddToHomeScreen}>
                Add to Home Screen
              </button>
              <button
                className="popup-dismiss-btn"
                onClick={handleDismissPopup}
              >
                Don't Show Again
              </button>
            </div>
          </div>
        </div>
      )}
    </Router>
  );
};

export default App;
